import { produce } from 'immer';

export default {
  saveSimplified: produce((state, entities) => {
    (entities || []).forEach((entity) => {
      const target = state.ids[entity.id] || {};
      state.ids[entity.id] = {
        ...target,
        ...entity,
        simplified: target?.simplified ?? true,
      };
    });
  }),
  saves: produce((state, entities) => {
    (entities || []).forEach((entity) => {
      state.ids[entity.id] = entity;
    });
  }),
  update: produce((state, entity) => {
    state.ids[entity.id] = {
      ...state[entity.id],
      ...entity,
    };
  }),
  remove: produce((state, entity) => {
    delete state.ids[entity.id];
  }),
};
